import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { Option } from 'antd/lib/mentions';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../../../../styles/pages/seller/_return-detailStock.scss';
import Recipient from '../../components/Recipient/Recipient';
import { DataType } from '../../interface';

interface Prop {
  productComment: any;
  recipient: any;
  commentTabsComponent: any;
  statusTitle?: string;
  canEdit?: boolean;
  setOpenSave?: any;
  onRecipientChange?: any;
}

const ReturnDetailStock = ({
  productComment,
  recipient,
  commentTabsComponent,
  statusTitle,
  canEdit,
  setOpenSave,
  onRecipientChange
}: Prop) => {
  const [dataStock, setDataStock] = useState([] as any);
  const location = useLocation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const listStatus = [
    {
      code: 'Request',
      name: '배송 요청'
    },
    {
      code: 'Inprogress',
      name: '배송중'
    },
    {
      code: 'Completed',
      name: '배송 완료'
    }
  ];
  const listStatusDisposal = [
    {
      code: 'Request',
      name: '폐기 요청'
    },
    {
      code: 'Inprogress',
      name: '폐기중'
    },
    {
      code: 'Completed',
      name: '폐기 완료'
    }
  ];
  const columns: ColumnsType<DataType> = [
    {
      title: 'Update Date',
      dataIndex: 'updated_at',
      width: '20%'
    },
    {
      title: 'Courier',
      dataIndex: 'courier'
    },
    {
      title: 'Tracking Number',
      dataIndex: 'trackingNumber'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    }
  ];
  useEffect(() => {
    const mapProductComment: any = [productComment];
    setDataStock(mapProductComment);
  }, [productComment]);

  const defaultValueDataOrder = useMemo(() => {
    return {
      trackingNumber: recipient ? recipient?.trackingNumber : '',
      status: recipient ? recipient?.warehouseReturnStatus : '',
      updated_at: recipient?.warehouseUpdateDate
        ? moment(recipient?.warehouseUpdateDate).utc()
        : null,
      courier: recipient ? recipient?.courier : ''
    };
  }, [recipient]);

  useEffect(() => {
    form.setFieldsValue(defaultValueDataOrder);
  }, [form, defaultValueDataOrder]);

  const dataSource = (): DataType[] => {
    return [
      {
        key: '1',
        updated_at: (
          <Form.Item>
            <Form.Item name={'updated_at'}>
              <DatePicker
                style={{ width: '100%' }}
                className="inputRadious"
                disabled={true}
                format={'YYYY.MM.DD hh:mm:ss a'}
                placeholder="YYYY.MM.DD 00:00:00"
              />
            </Form.Item>
          </Form.Item>
        ),
        courier: (
          <Form.Item
            name={['courier']}
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z\s]*$/),
                message: 'Only English can be entered'
              }
            ]}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
        ),
        trackingNumber: (
          <Form.Item
            name={['trackingNumber']}
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z0-9\s]*$/),
                message: 'Only English can be entered'
              }
            ]}
          >
            <Input className="inputRadious" disabled={true} />
          </Form.Item>
        ),
        status: (
          <Form.Item
            name={['status']}
            rules={[
              {
                required: true,
                message: 'Input status!'
              }
            ]}
          >
            <Select
              className="quantitySelect"
              disabled={true}
              // onChange={onChangeStatus}
            >
              <Option value="Inprogress">Inprogress</Option>
              <Option value="Complete">Complete</Option>
            </Select>
          </Form.Item>
        )
      }
    ];
  };

  return (
    <div className="detailStock">
      <Row style={{ padding: '10px', borderBottom: '1px solid #d9d9d9' }}>
        <Col span={12}>
          <strong>
            {recipient?.seller?.firstName ?? ''}{' '}
            {recipient?.seller?.lastName ?? ''}
          </strong>{' '}
          {recipient?.sellerId}
        </Col>
        <Col
          span={12}
          style={{ textAlign: 'end', color: 'gray', fontWeight: '300' }}
        >
          Update Date:
          {formatDateTime(recipient?.updated_at)}
        </Col>
      </Row>
      {canEdit ? (
        <Row style={{ padding: '10px' }}>
          <Col span={24} style={{ textAlign: 'end' }}>
            <span
              style={{ cursor: 'pointer', borderBottom: '1px solid' }}
              onClick={() => setOpenSave?.(true)}
            >
              저장하기
            </span>
          </Col>
        </Row>
      ) : null}
      <div style={{ padding: '25px', borderBottom: '1px solid #d9d9d9' }}>
        {dataStock.map((item: any) => {
          return (
            <>
              <DetailsPro
                productName={item.productName}
                width={item.width}
                height={item.height}
                length={item.length}
                demensionUnit={item.demensionUnit}
                weight={item.weight}
                weightUnit={item.weightUnit}
                estimateQuantity={item.estimateQuantity}
                averageMonthSale={item.averageMonthSale}
                sku={item.sku}
                eanUpc={item.eanUpc}
                asin={item.asin}
                packedMethod={item.packedMethod}
                storageMethod={item.storageMethod}
                dangerousGoods={item.dangerousGoods === true ? 'Yes' : 'No'}
                lotProduct={item.lotProduct}
                img={item.image?.url}
              />
            </>
          );
        })}
      </div>
      <div style={{ padding: '0px 25px' }}>
        <Recipient
          recipientName={recipient.recipientName}
          recipientPhone={recipient.recipientPhone}
          shippingAddress={recipient.detailReturnAddress}
          detailReturnAddress={recipient.detailReturnAddress}
          detailReturnAddress2={recipient.detailReturnAddress2}
          sellerComment={recipient.comment}
          street={recipient.street}
          city={recipient.city}
          state={recipient.state}
          postalCode={recipient.postalCode}
          country={recipient.country}
          returnReason={recipient.returnReason}
          statusReturn={
            location.pathname.includes('return-disposal')
              ? listStatusDisposal.find(
                  (x) => x.code === recipient.returnStatus
                )?.name
              : listStatus.find((x) => x.code === recipient.returnStatus)?.name
          }
          quantity={recipient.quantity}
          haveOneQuan
          statusTitle={statusTitle}
          canEdit={canEdit}
          canUpdate
          screenName="ReturnStockDetail"
          onChange={onRecipientChange}
        />
      </div>
      {commentTabsComponent}
      {/* <Form
        form={form}
        style={{ margin: 'auto' }}
        initialValues={{
          trackingNumber: defaultValueDataOrder.trackingNumber,
          status: defaultValueDataOrder.status,
          updated_at: defaultValueDataOrder.updated_at
            ? defaultValueDataOrder.updated_at
            : '',
          courier: defaultValueDataOrder.courier
        }}
      >
        <Table
          loading={loading}
          columns={columns}
          dataSource={dataSource()}
          pagination={false}
        />
      </Form> */}
    </div>
  );
};

export default ReturnDetailStock;
